export enum RMTypePaybleEnum {
    IMPORT_PAYABLE = 'IMPORT PAYABLE',
    IGST = 'IGST',
    DUTY_PAID = 'DUTY PAID',
    DOMESTIC = 'DOMESTIC',
}